import src from "IMAGE";
export default { src, width: 164, height: 143, blurWidth: 0, blurHeight: 0};
